var _style, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBid24SuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 400.1",
    style: {
      enableBackground: "new 0 0 450 400.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2a6dff;}\n\t.st1{fill:#2159d1;}\n\t.st2{fill:#DEECF1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,50.4v299.3c0,27.8-22.6,50.4-50.4,50.4H50.2C22.5,400.1,0,377.6,0,349.9V50C0,22.4,22.4,0,50,0h349.6 C427.4,0,450,22.6,450,50.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450,49.9v300c0,27.7-22.5,50.2-50.2,50.2H225V0h175.1C427.6,0,450,22.4,450,49.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.9,149L211,280.9c-9.8,9.8-25.6,9.8-35.4,0l-68.1-68.1c-9.8-9.8-9.8-25.6,0-35.4c9.8-9.8,25.6-9.8,35.4,0 l50.4,50.4l114.2-114.2c9.8-9.8,25.6-9.8,35.4,0C352.6,123.3,352.6,139.2,342.9,149z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBid24SuccessIcon);
export default __webpack_public_path__ + "static/media/bid_24_success_icon.3775ecc184f8f7fd09bffec734ae1a84.svg";
export { ForwardRef as ReactComponent };